var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ul',{staticClass:"my_list"},_vm._l((10),function(n,index){return _c('li',{key:index,attrs:{"id":n,"foisSix":_vm.foisSix}},[_vm._v(_vm._s(n))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5f11028","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cheap.vue
// module id = 171
// module chunks = 0